export default "__VITE_ASSET__CMngUt2I__"